import React, { type ReactNode, useRef } from 'react';
import Popover, { type PopoverHandle } from '../ui/overlay/Popover.component';

export interface UpgradePopoverContent {
	title: string;
	message: ReactNode;
}

export type UpgradePopoverActions =
	| ReactNode[]
	| ((closePopover: () => void) => ReactNode[]);

interface UpgradeIconPopoverProps {
	content: UpgradePopoverContent;
	actions: UpgradePopoverActions;
	triggerClassName: string;
	placement?: 'top' | 'bottom' | 'left' | 'right';
}

const UpgradeIconPopover = ({
	content,
	actions,
	triggerClassName,
	placement = 'right',
}: UpgradeIconPopoverProps) => {
	const popoverRef = useRef<PopoverHandle>(null);

	const resolvedActions =
		typeof actions === 'function'
			? actions(() => popoverRef.current?.close())
			: actions;

	return (
		<Popover
			ref={popoverRef}
			trigger={
				<span
					className={triggerClassName}
					onClick={e => e.stopPropagation()}
					role="button"
					tabIndex={0}
					aria-label="Upgrade information"
				/>
			}
			title={content.title}
			message={content.message}
			actionsLeft={resolvedActions}
			placement={placement}
			className="trial-upgrade-popover"
		/>
	);
};

export default UpgradeIconPopover;
